import React, { useRef } from "react";
import { SystemPageType } from "../../../../Model/SystemModels";
import { ListHeaderEntry } from "../../../Common/Template/List/ListHeaderEntry";
import PageContainer, { PageContainerBase } from "../../../Common/Template/PageContainer";
import { ContainerType, PageDefinitionContainer } from "../../../Common/Template/PageDefinitionContainer";
import { AdminBusinessCentralDefaultAppCard } from "../AdminBusinessCentralDefaultAppCard/AdminBusinessCentralDefaultAppCard";

export const AdminBusinessCentralDefaultAppList : React.FC = () => {
    const cardRef = useRef<PageContainerBase>(null);
    const pageRef = useRef<PageContainerBase>(null);
    
    return (
        <>
            <PageContainer endpoint="/odata/businesscentral/default/app?$orderby=priority asc" pageType={SystemPageType.List} title="BusinessCentral default app" backAllowed insertAllowed updateAllowed showAllowed ref={pageRef} cardRef={cardRef}>
                <PageDefinitionContainer type={ContainerType.Action}></PageDefinitionContainer>                    
                <PageDefinitionContainer type={ContainerType.PageStructure}>
                    <ListHeaderEntry fieldName="name" name="Nome" minWidth={100} maxWidth={200} />
                    <ListHeaderEntry fieldName="type" name="Tipo" minWidth={150} maxWidth={250} onRender={(item: any, index, column) => {
                        if (item.type === 0)
                            return "PerTenant"
                        else if (item.type === 1)
                            return "ISV"
                    }} />
                    <ListHeaderEntry fieldName="version" name="Versione" minWidth={150} maxWidth={250} />
                    <ListHeaderEntry fieldName="publisher" name="Publisher" minWidth={150} maxWidth={250} />
                </PageDefinitionContainer>
            </PageContainer>
            <AdminBusinessCentralDefaultAppCard ref={cardRef} />
        </>
    );
}